import React from 'react';
export function GallerySection() {
  const placeholders = ['IMAGE 01', 'IMAGE 02', 'IMAGE 03'];
  return <section className="bg-brand-black py-16 md:py-32 px-5 md:px-12 lg:px-24" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6" data-id="element-25">
          {placeholders.map((label, index) => <div key={index} className="aspect-[4/3] bg-brand-dark border border-brand-gold/40 flex items-center justify-center" data-id="element-26">
              <span className="font-mono text-brand-grey/50 text-sm uppercase tracking-label" data-id="element-27">
                {label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}